import React from 'react';
import { Box, Flex, Skeleton } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { DateRangeType } from '../../../common/components/DateRangeTypePicker';
import { groupByWeeks } from '../ev-charger-helper';
import { ChargingActivitySessionData } from '../types';
import { ChargingSessionCard } from './ChargingSessionCard';

type Props = {
  readonly isLoaded: boolean;
  readonly selectedDateRangeType: DateRangeType;
  readonly chargingSessions: ChargingActivitySessionData[];
};

export function ChargingSessionList({ isLoaded, selectedDateRangeType, chargingSessions }: Props) {
  const { t } = useTranslation();
  const isMonthView = selectedDateRangeType === DateRangeType.Month;
  let sessionsData: ChargingActivitySessionData[] = [];

  if (!chargingSessions.length) return null;

  if (isMonthView) {
    sessionsData = groupByWeeks(chargingSessions);
  } else {
    sessionsData = chargingSessions;
  }

  return (
    <Box mt={6} w="100%">
      <Flex borderTop="1px solid" borderColor="#BDBEC0" align="Center" justify="space-between">
        <Box mt={8} mb={3}>
          {t(`EVSE.sessionDateRangeType.${selectedDateRangeType}`).toUpperCase()}
        </Box>
      </Flex>

      <Skeleton isLoaded={isLoaded}>
        {sessionsData.map((session) => {
          if (session.cost === 0 && session.usage === 0) return;
          return (
            <ChargingSessionCard
              key={session.id}
              chargingSession={session}
              selectedDateRangeType={selectedDateRangeType}
            />
          );
        })}
      </Skeleton>
    </Box>
  );
}
